<template>
  <div>
    <div class="headline">
      {{ $t('checkout.title') }}
    </div>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation

    >
      <v-row dense>
        <v-col
            cols="12"
            lg="6"
        >
          <v-text-field
              v-model="person.firstname"
              :rules="nameRules"
              :label="$t('checkout.firstname')"
              required
          ></v-text-field>
        </v-col>
        <v-col
            cols="12"
            lg="6"
        >
          <v-text-field
              v-model="person.lastname"
              :rules="nameRules"
              :label="$t('checkout.lastname')"
              required
          ></v-text-field>
        </v-col>
<!--        <v-col-->
<!--            cols="12"-->
<!--            lg="12"-->
<!--        >-->
<!--          <v-text-field-->
<!--              v-model="person.street"-->
<!--              :rules="nameRules"-->
<!--              :label="$t('checkout.street')"-->
<!--              required-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
<!--        <v-col-->
<!--            cols="12"-->
<!--            lg="4"-->
<!--        >-->
<!--          <v-text-field-->
<!--              v-model="person.zip"-->
<!--              :rules="nameRules"-->
<!--              :label="$t('checkout.zip')"-->
<!--              required-->
<!--              type="number"-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
<!--        <v-col-->
<!--            cols="12"-->
<!--            lg="8"-->
<!--        >-->
<!--          <v-text-field-->
<!--              v-model="person.city"-->
<!--              :rules="nameRules"-->
<!--              :label="$t('checkout.city')"-->
<!--              required-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
<!--        <v-col-->
<!--            cols="12"-->
<!--            lg="12"-->
<!--        >-->
<!--          <v-select-->
<!--              v-model="person.country"-->
<!--              :items="countries"-->
<!--              :rules="nameRules"-->
<!--              :label="$t('checkout.country')"-->
<!--              required-->
<!--          ></v-select>-->
<!--        </v-col>-->
        <v-col
            cols="12"
            lg="12"
        >
          <v-text-field
              v-model="person.email"
              :rules="emailRules"
              :label="$t('checkout.email')"
              required
          ></v-text-field>
        </v-col>
<!--        <v-col-->
<!--            cols="12"-->
<!--            lg="12"-->
<!--        >-->
<!--          <v-text-field-->
<!--              v-model="person.phone"-->
<!--              :rules="nameRules"-->
<!--              :label="$t('checkout.phone')"-->
<!--              required-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
      </v-row>
      <v-row dense>
        <v-col class="text-left theme--light" cols="12" sm="12" md="12" lg="6">
          <order-amount
              :price="price"
              :min="min"
              :max="max"
              @change="onAmountChanged"
          ></order-amount>

        </v-col>
        <v-col class="text-right" cols="12" sm="12" md="12" lg="6">
          <!--        <span class="headline font-weight-light">{{ quantity }} x {{ price.toFixed(2) }}</span>-->
          <span class="headline font-weight-light">{{ quantity }} x {{ price.toFixed(2)  | currency }}</span>
          <span class="subheading font-weight-light mr-1"> €</span><br>
          <span class="headline font-weight-bold">Gesamt: {{ total.toFixed(2)  | currency }}</span>
          <span class="subheading font-weight-bold mr-1"> €</span><br>
          <span class="caption font-weight-light mr-1">inkl. {{ (total - total / 1.2).toFixed(2) | currency }} € MwSt.</span>
        </v-col>

        <!--      <v-col-->
        <!--          cols="12"-->
        <!--          md="12"-->
        <!--      >-->
        <!--                <v-slider-->
        <!--                    v-model="count"-->
        <!--                    color="orange"-->
        <!--                    label="Menge"-->
        <!--                    max="10"-->
        <!--                    min="1"-->
        <!--                    thumb-label-->
        <!--                    tick-size="4"-->
        <!--                    ticks="always"-->
        <!--                >-->
        <!--                  <template v-slot:prepend>-->
        <!--                    <v-icon-->
        <!--                        color="orange"-->
        <!--                        @click="count&#45;&#45;"-->
        <!--                    >-->
        <!--                      mdi-minus-->
        <!--                    </v-icon>-->
        <!--                  </template>-->

        <!--                  <template v-slot:append>-->
        <!--                    <v-icon-->
        <!--                        color="orange"-->
        <!--                        @click="count++"-->
        <!--                    >-->
        <!--                      mdi-plus-->
        <!--                    </v-icon>-->
        <!--                  </template>-->
        <!--                </v-slider>-->
        <!--      </v-col>-->
      </v-row>


      <v-row dense>
        <v-col
            cols="12"
            lg="12"
        >
            <v-checkbox
                v-model="person.newsletter"
                :label="$t('checkout.accept_newsletter')"
            ></v-checkbox>
<!--          <v-checkbox-->
<!--                v-model="person.postcard"-->
<!--                label="Ich möchte zukünftig einen personalisierten Newsletter mit meinem zur Verfügung gestellten Bild/Foto von Lustenau Marketing empfangen"-->
<!--            ></v-checkbox>-->
          <v-checkbox
              v-model="privacy"
              :rules="nameRules"
              :label="$t('checkout.accept_gprd')"
              required
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-radio-group
              v-model="payment"
              :rules="nameRules"
              column
              label="Bezahlung"
          >
            <v-radio
                label="Bezahlen bei Abholung"
                value="paylater"
            >
              <template v-slot:label>
                <div>bei Abholung zahlen<br><strong class="caption">Sônggl werden erst beim Bezahlen erstellt. Es kann zu Wartezeiten kommen.</strong></div>
              </template>
            </v-radio>
            <v-radio
                label="Jetzt bezahlen"
                value="paynow"
            >
              <template v-slot:label>
                <!-- <div>jetzt online zahlen<br><strong class="caption">Sônggl werden nach Möglichkeit sofort erstellt</strong></div>-->
                <div>jetzt online zahlen<br><strong class="caption">Sônggl können am Kilbi-Stand bei Kilbi 2026 abgeholt werden</strong></div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="mb-5" dense>
        <v-col class="text-center" align="center">
          <v-btn rounded large color="secondary buttonColor--text" @click="validate()" :loading="loading">{{ $t('checkout.buy') }}</v-btn>
        </v-col>
      </v-row>

<!--      <v-row-->
<!--          class="mb-2" no-gutters-->
<!--      >-->
<!--        <v-col class="text-left caption">-->
<!--          <div> Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text Text-->
<!--            Text Text Text Text Text Text Text Text Text Text Text-->
<!--          </div>-->

<!--        </v-col>-->
<!--      </v-row>-->

    </v-form>
  </div>



</template>

<script>
import OrderAmount from "./OrderAmout";
import {mapState} from 'vuex'

export default {
  name: "UploadForm",
  components: {OrderAmount},
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    price: 6.7,
    min: 1,
    max: 10,
    total: 0,
    quantity: 0,

    valid: false,
    countries: ['Österreich', 'Deutschland', 'Schweiz'],
    privacy: false,
    person: {
      firstname: '',
      lastname: '',
      street: '',
      zip: '',
      city: '',
      email: '',
      phone: '',
      newsletter: false,
      postcard: false
    },
    payment: null,
    nameRules: [
      v => !!v || 'Pflichtfeld',
    ],
    emailRules: [
      v => !!v || 'Pflichtfeld',
      v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-Mail ist ungültig',
    ],
  }),
  computed: {
    ...mapState('user', {
      loggedin: state => state.loggedin,
      user: state => state.user,
      userClaims: state => state.claims,
    })
  },
  mounted() {
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
          this.$emit('submit', {person: this.person, order: {quantity: this.quantity, price: this.price, total: this.total},  payment: { payment: this.payment }})
      }
    },
    onAmountChanged(value) {
      this.quantity = value.count;
      this.total = value.total;
    },
    uploadData() {
    },
  }
}
</script>

<style scoped>

</style>
